/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { normalizePermission } from '@gh/core-auth';
import { UserContext } from '../user/user-context';

export function verifyEntity(entity: any | any[], fn: (entity: any) => boolean): boolean {
  if (Array.isArray(entity)) {
    if (entity.length > 0) {
      return entity.some(fn);
    } else {
      return true;
    }
  } else if (entity) {
    return fn(entity);
  } else {
    return true;
  }
}

function verifyRoutePermission(route: ActivatedRouteSnapshot, userContext: UserContext): boolean {
  const permission = route.data['permission'];
  return verifyEntity(permission, (p) => userContext.hasPermission(normalizePermission(p)));
}

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean => {
  const router = inject(Router);
  const userContext = inject(UserContext);
  const canNavigate = verifyRoutePermission(route, userContext);
  if (!canNavigate) {
    router.navigateByUrl('/404');
    return false;
  }
  return true;
};

export function verifyRoutePermissionOnly(route: ActivatedRouteSnapshot, userContext: UserContext): boolean {
  return verifyRoutePermission(route, userContext);
}
